import axios from "../../../../api/axios";

interface FollowResponse {
  isFollowing: boolean;
}

export const followUserService = async (userId: number): Promise<boolean> => {
  try {
    const response = await axios.patch<FollowResponse>(`users/${userId}/follow`);
    return response.data.isFollowing;
  } catch (error) {
    throw new Error(`Failed to follow user: ${error}`);
  }
};

export const unfollowUserService = async (userId: number): Promise<boolean> => {
  try {
    const response = await axios.delete<FollowResponse>(`users/${userId}/follow`);
    return response.data.isFollowing;
  } catch (error) {
    throw new Error(`Failed to unfollow user: ${error}`);
  }
};
